import PropTypes from 'prop-types'
import { useTheme } from '@emotion/react'
import { text } from 'chaoskit/src/assets/styles/utility'

import Icon from '~components/Icon'
import ButtonLink from '~components/ButtonLink'

const ArticleFooter = ({
  homeLabel = 'Home',
  homeUrl,
  navigation,
  nextLabel = 'Next section',
  prevLabel = 'Previous section',
  ...rest
}) => {
  const theme = useTheme()

  return (
    <footer
      css={[
        text.heading(theme),
        {
          marginTop: theme.space.xlarge,
          display: 'flex',
          justifyContent: 'space-between',
          fontWeight: theme.fontWeight.bold,
          fontSize: theme.fontSize.small,
          alignItems: 'center',

          '[disabled]': {
            opacity: theme.opacity.base,
            cursor: 'not-allowed',
            pointerEvents: 'none',
          },
        },
      ]}
      {...rest}
    >
      <ButtonLink
        disabled={!navigation.previous}
        type="reset"
        css={{ display: 'inline-block' }}
        url={navigation.previous?.fields?.fullUrl}
      >
        <Icon icon="caret-left" css={{ marginRight: theme.space.small }} />
        <span
          css={{
            [theme.mq.small__max]: {
              display: 'none',
            },
          }}
        >
          {prevLabel}
        </span>
      </ButtonLink>
      <ButtonLink type="reset" css={{ display: 'inline-block' }} url={homeUrl}>
        <Icon icon="home" css={{ marginRight: theme.space.small }} />
        <span
          css={{
            [theme.mq.small__max]: {
              display: 'none',
            },
          }}
        >
          {homeLabel}
        </span>
      </ButtonLink>
      <ButtonLink
        disabled={!navigation.next}
        type="reset"
        css={{ display: 'inline-block' }}
        url={navigation.next?.fields?.fullUrl}
      >
        <span
          css={{
            [theme.mq.small__max]: {
              display: 'none',
            },
          }}
        >
          {nextLabel}
        </span>
        <Icon icon="caret-right" css={{ marginLeft: theme.space.small }} />
      </ButtonLink>
    </footer>
  )
}

ArticleFooter.propTypes = {
  navigation: PropTypes.shape({
    previous: PropTypes.object,
    next: PropTypes.object,
  }).isRequired,
  next: PropTypes.object,
  prevLabel: PropTypes.string,
  homeLabel: PropTypes.string,
  homeUrl: PropTypes.string.isRequired,
  nextLabel: PropTypes.string,
}

export default ArticleFooter
